/** Simple HQ constants — distinct from Early Signals / platform isAdmin */

/** The Simple Intel company (prod). Prefer RPC simple_hq_company_id() at runtime. */
export const SIMPLE_HQ_COMPANY_ID = 'e2761c84-c430-4d71-be91-b1b5225bf8f7'

/**
 * Nav visibility — not the same as HQ admin. Membership is finalized by ensure_simple_hq_member.
 * When an admin is View-as previewing another tenant (e.g. Kenvue), hide Simple HQ so client
 * preview chrome does not show internal ops.
 */
export function canSeeSimpleHqNav(
  email: string | null | undefined,
  companyId: string | null | undefined,
  viewAsCompanyId?: string | null
): boolean {
  if (viewAsCompanyId && viewAsCompanyId !== SIMPLE_HQ_COMPANY_ID) return false
  if (!email) return false
  const e = email.toLowerCase()
  if (e.endsWith('@thesimpleintel.com') || e.endsWith('@thesimple.com')) return true
  return companyId === SIMPLE_HQ_COMPANY_ID
}

export type SimpleHqRole = 'admin' | 'delegate' | 'member'

export type LeaveRequestStatus = 'pending' | 'approved' | 'denied' | 'cancelled'

export type HqTaskStatus = 'backlog' | 'active' | 'waiting' | 'done' | 'cancelled'

export type HqTaskPriority = 'urgent' | 'high' | 'medium' | 'low'

export const HQ_TASK_STATUSES: HqTaskStatus[] = ['backlog', 'active', 'waiting', 'done', 'cancelled']

export const HQ_PRIORITIES: HqTaskPriority[] = ['urgent', 'high', 'medium', 'low']

export const HQ_FROM_EMAIL = 'Simple HQ <noreply@theearlysignals.com>'

export function currentLeaveYear(d = new Date()): number {
  return d.getFullYear()
}
